import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-disabledInput';
	$(base, context).each(function(){
		var component = $(this);
		var checkbox = component.find(base + '-checkbox');
		var input =  component.find(base + '-input');
		var field =  component.find(base + '-field');

		checkbox.change(function() {
			input.attr('disabled',!this.checked);
			field.toggleClass('m-disabled', !this.checked);
		});
	});
});



//////////////////
// WEBPACK FOOTER
// ./src/components/i-disabledInput.js
// module id = 54
// module chunks = 0